<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />
    
    <!-- formulario -->
    <v-row justify="center">
      <v-col 
        cols="12" 
        sm="10" 
        lg="8"
      >
        <v-card 
          outlined 
          elevation="2" 
          :loading="formLoading"
        >
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">
              Registrar Aliado
            </p>
          </v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-col 
                cols="12" 
                sm="10" 
                lg="8"
              >
                <v-form 
                  ref="form" 
                  v-model="form"
                >
                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Aliado*"
                    maxlength="150"
                    counter
                    autofocus
                    v-model="aliado"
                    :rules="aliadoReglas"
                  >
                  </v-text-field>

                  <v-file-input
                    outlined
                    dense
                    prepend-icon=""
                    append-icon="mdi-paperclip"
                    accept="image/png, image/jpeg"
                    label="Logotipo"
                    truncate-length="50"
                    counter
                    show-size
                    v-model="logotipo"
                    :rules="logotipoReglas"
                  >
                  </v-file-input>

                  <v-textarea
                    outlined
                    rows="4"
                    label="Descripción"
                    v-model="descripcion"
                  >
                  </v-textarea>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Dirección*"
                    maxlength="50"
                    counter
                    v-model="direccion"
                    :rules="direccionReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="number"
                    label="Teléfono*"
                    v-model="telefono"
                    maxlength="10"
                    counter
                    :rules="telefonoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Correo Electrónico*"
                    maxlength="50"
                    counter
                    v-model="correo"
                    :rules="correoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Contacto del Aliado"
                    maxlength="100"
                    counter
                    v-model="contactoAliado"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="number"
                    label="Teléfono Contacto Aliado"
                    maxlength="10"
                    counter
                    v-model="telefonoContactoAliado"
                    :rules="telefonoContactoAliadoReglas"
                  >
                  </v-text-field>

                  <v-text-field
                    outlined
                    dense
                    type="text"
                    label="Correo Electrónico Contacto Aliado"
                    maxlength="50"
                    counter
                    v-model="correoContactoAliado"
                    :rules="correoContactoAliadoReglas"
                  >
                  </v-text-field>

                  <v-btn
                    block
                    large
                    exact
                    elevation="2"
                    color="primary"
                    class="mt-2 mb-6"
                    @click="registrar"
                  >
                    Registrar
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    form: true,
    formLoading: false,
    
    aliado: '',
    aliadoReglas: [
      v => !!v || "Escriba un aliado"
    ],

    logotipo: null,
    logotipoReglas: [
      v => !v || v.size < 2000000 || "El tamaño del logotipo debe ser menor que 2 MB"
    ],

    descripcion: '',

    direccion: '',
    direccionReglas: [
      v => !!v || "Escriba una dirección"
    ],

    telefono: '',
    telefonoReglas: [
      v => !!v || "Escriba un número de teléfono",
      v => !v || v > 0 || "El número debe ser mayor a 0",
      v => !v || v.length <= 10 || "Maximo 10 digitos"
    ],

    correo: '',
    correoReglas: [
      v => !!v || "Escriba un correo electrónico",
      v => /.+@.+\..+/.test(v) || "Correo electrónico no válido"
    ],

    contactoAliado: '',

    telefonoContactoAliado: '',
    telefonoContactoAliadoReglas: [
      v => !v || v > 0 || "El número debe ser mayor a 0",
      v => !v || v.length <= 10 || "Maximo 10 digitos",
    ],

    correoContactoAliado: '',
    correoContactoAliadoReglas: [
      v => !v || /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ]
  }),

  components: {
    Alert
  },

  methods: {
    registrar() {
      if (this.$refs.form.validate()) {
        const aliado = new FormData();
        aliado.set("aliado",                    this.aliado.toLowerCase());
        aliado.set("logotipo",                  this.logotipo);
        aliado.set("descripcion",               this.descripcion);
        aliado.set("direccion",                 this.direccion);
        aliado.set("telefono",                  this.telefono);
        aliado.set("correo",                    this.correo.toLowerCase());
        aliado.set("contacto_aliado",           this.contactoAliado);
        aliado.set("telefono_contacto_aliado",  this.telefonoContactoAliado);
        aliado.set("correo_contacto_aliado",    this.correoContactoAliado.toLowerCase());

        this.formLoading = true;

        this.$store.dispatch("registrarAliado", aliado)
        .then((response) => {
          if (response.status == "success") {
            this.$refs.form.reset();
            this.formLoading  = false;

            this.alertType    = "success--text";
            this.alertTitle   = "Registrado";
            this.alertMessage = response.message;
            this.alert        = true;

            setTimeout(() => {
              this.alert = false
              this.$router.replace({ name: "campesena-aliado-gestionar" });
            }, 2000);
          } 
          else {
            this.formLoading  = false;
            this.alertType    = "error--text";
            this.alertTitle   = "Error";
            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }
            this.alert        = true;

            setTimeout(() => {
              this.alert = false;
            }, 3000);
          }
        })
        .catch(() => {});
      }
    }
  }
};
</script>